
  import { defineComponent } from "vue"
  export default defineComponent({
    name: "Panel",
    inject: ["Ti18N"],
    emits: ["openModal", "setOpenPanel", "editWords"],
    props: {
      title: String,
      words: Array,
      userID: String
    },
  })
